import { render, staticRenderFns } from "./HomeProntoPago.vue?vue&type=template&id=1a786768&scoped=true&"
import script from "./HomeProntoPago.vue?vue&type=script&lang=ts&"
export * from "./HomeProntoPago.vue?vue&type=script&lang=ts&"
import style0 from "./HomeProntoPago.vue?vue&type=style&index=0&id=1a786768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a786768",
  null
  
)

export default component.exports